// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { initializeFirestore, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { getStorage, } from 'firebase/storage';
import { getAnalytics } from "firebase/analytics";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getMessaging, isSupported as isMessagingSupported } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Push messaging is unavailable on some browsers (e.g. iOS Safari outside an
// installed PWA). getMessaging() rejects ASYNCHRONOUSLY there, so a try/catch
// can't contain it — gate it behind the SDK's own async isSupported() check.
let messaging = null;
isMessagingSupported()
  .then((supported) => {
    if (supported) messaging = getMessaging(app);
  })
  .catch(() => {
    // unsupported environment — push features stay disabled
  });
// Initialize Analytics (only in production)
let analytics;
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  analytics = getAnalytics(app);
}

// Initialize Auth
const auth = getAuth(app);

// Initialize Firestore with optimized settings to prevent "Unknown SID" errors
const firestore = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
  experimentalForceLongPolling: true,
  ignoreUndefinedProperties: true,
}, process.env.REACT_APP_FIREBASE_DATABASE_ID || '(default)');

// Initialize Storage
const storage = getStorage(app);
const functions = getFunctions(app);
if (window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches) {
  console.log('🏠 Running in standalone PWA mode');
  
  auth.onAuthStateChanged(async (user) => {
    if (user) {
      try {
        await user.getIdToken(true); // Force refresh
        console.log('✅ Token refreshed for PWA');
      } catch (error) {
        console.error('❌ Token refresh failed:', error);
      }
    }
  });
}
// Initialize Functions (uncomment for local development)
// const functions = getFunctions(app);
// connectFunctionsEmulator(functions, "localhost", 5001);

export { app, auth, firestore, storage, functions, analytics, messaging };